export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "container_controlled": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("nalb")), " read ability is controlled by the container type read ability"])}
      },
      "fr": {
        "container_controlled": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("nalb")), " la capacité de lecture est contrôlée par la capacité de lecture du type de conteneur"])}
      }
    }
  })
}